export const Topics = {
    generateUploadPresigned: 'presigned'
}

export type Request = {
    type: string
    folder: string
    fileName: string
}

export type Response = {
    provider: string
    key: string
    uploadUrl: string
}
